import { getAxios } from '../../lib/projectAxios'
import uuid from 'uuid/v4'
const axios = getAxios()
import { fromJS, Map, List, isImmutable } from 'immutable'
import { getParams, getState } from '../../lib/processPortalRules'
import _ from 'lodash'
import { CLOSE_LOADING_WINDOW, SHOW_LOADING_WINDOW } from './actionTypes'

export const processVirusScan = async (node, getAppState, dispatch) => {
  try {
    let sett = _.get(node, ['data', 'VirusScan', 0])
    if (!sett || !sett.files || !sett.files.length) {
      return {
        status: false,
      }
    }
    let state = getAppState()
    if (!sett.runInBackground) {
      dispatch({
        type: SHOW_LOADING_WINDOW,
        payload: {
          messages: [],
        },
      })
    }

    const RepeatedStripsID = state.getIn(['project', 'Settings', 'RepeatedStripsID'], List()).toJS()
    let isHaveFiles = false

    let formData = new FormData()

    _.each(sett.files, function (mapFile) {
      if (mapFile) {
        const files = _.get(window, ['__FT_PROJECT__API__FILES__', 'files', mapFile.uid], {})
        if (files) {
          let fieldPath = String(mapFile.value).split(':')
          if (RepeatedStripsID.includes(fieldPath[1])) {
            _.each(files, (section, index) => {
              if (section && section.files) {
                _.each(section.files, function (file) {
                  isHaveFiles = true
                  formData.append('attachment', file)
                })
              }
            })
          } else {
            _.each(files.files, (file) => {
              isHaveFiles = true
              formData.append('attachment', file)
            })
          }
        }
      }
    })

    if (!isHaveFiles) {
      if (!sett.runInBackground) {
        dispatch({ type: CLOSE_LOADING_WINDOW })
      }
      return {
        status: false,
      }
    }

    const recursiveProcessVirusScan = async (attemp) => {
      if (attemp >= 3) {
        return {
          status: 200,
          data: {
            status: false,
          },
        }
      }
      try {
        let result = await axios.post('/webprojects/flow/virusScan', formData)
        return result
      } catch (err) {
        console.log('err >>> ', err)
        await new Promise((resolve) => {
          setTimeout(resolve, 2 * 1000)
        })

        return recursiveProcessVirusScan(attemp + 1)
      }
    }

    const { status, data } = await recursiveProcessVirusScan(0)

    if (!sett.runInBackground) {
      dispatch({ type: CLOSE_LOADING_WINDOW })
    }
    return data
  } catch (err) {
    console.error(err)
  }

  return {
    status: true,
  }
}
